(function (window, $) {
    $('body').on('change', '[data-toggle-password]', togglePassword);

    /**
     * Toggle password input field type.
     *
     * @return undefined
     */
    function togglePassword() {
        var field = $($(this).attr('data-toggle-password'));
        var showPassword = $(this).prop('checked');

        if (showPassword) {
            field.prop('type', 'text');
        } else {
            field.prop('type', 'password');
        }
    }
})(window, jQuery);
